export enum PusherEvents {
  "BULK_LABELS_CREATED" = "BULK_LABELS_CREATED",
  "LABEL_JOB_COMPLETED" = "LABEL_JOB_COMPLETED",
  "QUOTE_CREATED" = "QUOTE_CREATED",
}
